import {
  compareStrings,
  displayTranslations,
  getArtwork,
  parseCategoryName,
  parseLanguage,
  titleize
} from "../../utils/utils";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import I18n from "i18n-js";
import GameNameParser from "./GameNameParser";
import React from "react";
import ExpansionIcon from "./ExpansionIcon";
import LanguageFlag from "./LanguageFlag";

const  BlueprintImageFullDetails = ({
    blueprintImage,
    handleShowLargeImage,
    defaultCursor
  }) => {

  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)
  const eraNames = displayTranslations(blueprintImage.en_era_name, blueprintImage.era_name, blueprintImage.language)
  const expansionNames = displayTranslations(blueprintImage.en_expansion_name, blueprintImage.expansion_name, blueprintImage.language)

  return (
    <div className="d-flex">
      <div className="d-flex align-items-center"
       onClick={(e) => e.stopPropagation()}>
        <ShowBlueprintImageFrontImage
          size={'medium'}
          blueprintImage={blueprintImage}
          handleShowLargeImage={handleShowLargeImage}
          cursor={blueprintImage.medium_image_url ? 'zoom-in' : defaultCursor}
          textOverlayPlaceholder={getArtwork(blueprintImage)}
        />
      </div>
      <div className="d-flex align-items-center">
        <div className="ml-4 d-block">
          <p id={"name_" + blueprintImage.id} className="mb-0">
            {
              blueprintImageNames.length > 1 ?
                <b>
                  { blueprintImageNames[0] }
                  <small className="ml-1">
                    <b>
                      ({ blueprintImageNames[1] })
                    </b>
                  </small>
                </b>
                :
                <b>
                  { blueprintImageNames[0] }
                </b>
            }
          </p>
          <p className="mb-0">
            {
              blueprintImage.collector_number &&
              <span>{  blueprintImage.collector_number }</span>
            }
          </p>
          <p className="mb-0">
            {
              blueprintImage.print_sheet_code &&
              <span>{  blueprintImage.print_sheet_code}</span>
            }
          </p>
          <GameNameParser
            game_name={blueprintImage.game.name}
            additionalClasses1={"mb-0"}
          />

          {
            (blueprintImage.en_era_name || blueprintImage.era_name) &&
              <p id={"era_" + blueprintImage.id} className="mb-0">
                {
                  eraNames.length > 1 ?
                    <span>
                      { eraNames[0] }
                      <small className="ml-1">
                        ({ eraNames[1] })
                      </small>
                    </span>
                  :
                    <span>
                      { eraNames[0] }
                    </span>
                }
              </p>
          }

          <p id={"expansion_" + blueprintImage.id} className="mb-0">
            {
              expansionNames.length > 1 ?
                <span>
                  { expansionNames[0] }
                  <small className="ml-1">
                    ({ expansionNames[1] })
                  </small>
                </span>
              :
                <span>
                  { expansionNames[0] }
                </span>
            }
            {
              blueprintImage.expansion.icon_url &&
                <ExpansionIcon
                  icon_url={blueprintImage.expansion.icon_url}
                  width={'20px'}
                />
            }
          </p>
          <p id={"category_" + blueprintImage.id} className="mb-0">
            {I18n.t('js.filters.sort.category')}:&nbsp;
            { parseCategoryName(blueprintImage.blueprint.category.name) }
          </p>
          <div className="d-flex align-items-center mb-0">
            {I18n.t('js.cardInfoPage.language')}:&nbsp;
            <span className="mr-2">
              { parseLanguage(blueprintImage.language_filter) }
            </span>
            <LanguageFlag
              language={blueprintImage.language}
              maxHeight={'15px'}
            />
          </div>
          <p id={"version_" + blueprintImage.id} className="mb-0">
            {
              blueprintImage.version &&   blueprintImage.version !== '' &&
              <span>
                {I18n.t('js.filters.sort.version')}:&nbsp;
                { titleize(  blueprintImage.version) }
              </span>
            }
          </p>
          <p id={"rarity_" + blueprintImage.id} className="mb-0">
            {
              blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') &&
              <span>
                {I18n.t('js.filters.sort.rarity')}:&nbsp;
                { titleize(  blueprintImage.rarity) }
                {
                  blueprintImage.rarity_logo_url &&
                  <img src={  blueprintImage.rarity_logo_url} alt="" className="ml-1" style={{ maxWidth: '20px'}}/>
                }
            </span>
            }
          </p>
          <p className="mb-0">
            {
              blueprintImage.edition && !compareStrings(blueprintImage.edition, 'Undefined') && blueprintImage.edition !== "" &&
              <span>
                {I18n.t('js.filters.sort.edition')}:&nbsp;
                { titleize(  blueprintImage.edition) }
              </span>
            }
          </p>
          <p className="mb-0">
            {
              blueprintImage.version &&   blueprintImage.released_at !== '' &&
              <span>
                {I18n.t('js.filters.sort.releaseDate')}:&nbsp;
                { titleize( blueprintImage.released_at) }
              </span>
            }
          </p>
        </div>
      </div>
    </div>
  );
}

export default  BlueprintImageFullDetails;
